export default __webpack_public_path__ + "static/media/audio.cd33a4e3.mp3";